import { useMutation, useQueryClient } from '@tanstack/react-query';
import { changeAppointmentState, isApiError } from '@uplift/api';
import { SessionState } from '@uplift/types';


export const useChangeAppointmentStateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: { appointmentId: string; state: SessionState }) => {
      try {
        return await changeAppointmentState(params.appointmentId, params.state);
      } catch (err) {
        if (isApiError(err)) {
          return { error: err.message };
        } else if (err instanceof Error) {
          return { error: err.message };
        }

        return { error: String(err) };
      }
    },
    async onSuccess(_data, variables) {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: [ 'appointment', variables.appointmentId ] }),
      ]);
    },
  });
};


// FIXME: REMOVE THIS, REPLACE WITH DIRECT useChangeAppointmentStateMutation CALL
export const useChangeAppointmentState = () => {
  const changeAppointmentStateMutation = useChangeAppointmentStateMutation();

  const changeAppointmentState = async (appointmentId: string, state: SessionState) => {
    return await changeAppointmentStateMutation.mutateAsync({
      appointmentId,
      state
    });
  };

  return {
    changeAppointmentState,
  };
};
